/* eslint-disable @typescript-eslint/no-explicit-any */
import { Directive, HostListener, Input } from "@angular/core";
import { Store } from "@ngrx/store";
import { STATUS_BAR_MODULE_SELECTED } from "../../state/actions/button-click.actions";
import { ButtonsState } from "src/app/state/buttons-state";
import { ROUTES } from "../constants/routes";

@Directive({
    selector: "[appSetDefaultModule]",
    standalone: true
})
export class SetDefaultModuleDirective {

    @Input() defaultModuleName: any | undefined;
    private defaultModules = [ROUTES.HOME_CAFE, ROUTES.МАX_VOUCHERS];

    constructor(private buttonsStore: Store<ButtonsState>) { }

    @HostListener("click") onClick() {
        const button = this.defaultModuleName!;
        if (this.defaultModules.includes(button)) {
            this.buttonsStore.dispatch(STATUS_BAR_MODULE_SELECTED({ button }));
        }
    }
}